import React, { useCallback, useState } from "react";
import { useAuth } from "../context/authContext";
import { paymentService, formatApiError } from "../services/api";
import RechargeModal from "../views/utils/components/RechargeModal/RechargeModal";
import PaycashInstructionsModal from "../views/utils/components/PaycashInstructionsModal";

/**
 * Flujo de recarga compartido (menú de perfil y botón "Recargar" del header):
 * RechargeModal (monto) → paymentService.createRecharge → PaycashInstructionsModal.
 *
 * @returns {{ openRecharge: () => void, rechargeModals: JSX.Element }}
 *   `rechargeModals` debe renderizarse una vez en el componente que usa el hook.
 */
export default function useRechargeFlow() {
  const { user } = useAuth();
  const [showRechargeModal, setShowRechargeModal] = useState(false);
  const [instructionsRecharge, setInstructionsRecharge] = useState(null);

  const openRecharge = useCallback(() => setShowRechargeModal(true), []);
  const closeRecharge = useCallback(() => setShowRechargeModal(false), []);
  const closeInstructions = useCallback(() => setInstructionsRecharge(null), []);

  const handleRecharge = useCallback(async (amount) => {
    const result = await paymentService.createRecharge({
      monto: amount,
      descripcion: "Recarga de saldo",
    });

    if (!result.ok) {
      throw new Error(
        formatApiError(result.data) || "No se pudo crear la recarga"
      );
    }

    setInstructionsRecharge(result.data);
  }, []);

  const currentBalance = user?.balance?.amount ?? user?.balance ?? undefined;

  const rechargeModals = (
    <>
      <RechargeModal
        isOpen={showRechargeModal}
        onClose={closeRecharge}
        currentBalance={currentBalance}
        onRecharge={handleRecharge}
      />

      <PaycashInstructionsModal
        isOpen={!!instructionsRecharge}
        onClose={closeInstructions}
        recharge={instructionsRecharge}
      />
    </>
  );

  return { openRecharge, rechargeModals };
}
